import { postJson } from '../../http'

export default {
    // 查询授权邀请列表
    fetchInviteList(data) {
        return postJson('/lz/console/authinvite/person/find/list', data)
    },
    // 查询处理邀请记录
    fetchInviteRecords(data) {
        return postJson('/lz/console/authinvite/person/find/audithis/list', data)
    },
    // 处理邀请
    handleInvite(data) {
        return postJson('/lz/console/authinvite/person/audit', data)
    },
    // 查询加入的组织列表
    fetchJoinedList(data) {
        return postJson('/lz/console/auth/person/find/list', data)
    },
    // 查询单个授权邀请详情
    fetchInviteOne(data) {
        return postJson('/lz/console/authinvite/person/find/one', data)
    },
    /**
     * 查询组织信息
     */
    fetchOrganization() {
        return postJson('/lz/console/organization/queryOrganization')
    }
}



// WEBPACK FOOTER //
// ./src/api/modules/user/organization.js